import { FooterBlur } from "@/components/landing/background-blur";
import { FadeUp } from "@/components/ui/animated";
import { Link } from "@/components/landing/link";

const links = [
  {
    title: "Vessa",
    links: [
      { label: "Build my journal", href: "/quiz", title: "Start the web quiz" },
      { label: "Medication sources", href: "/medication-sources", title: "Official medication sources" },
      { label: "Support", href: "/support", title: "Product support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", href: "/privacy", title: "Read our privacy policy" },
      {
        label: "Terms",
        href: "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/",
        title: "Read Apple's Standard EULA",
      },
    ],
  },
];

export function Footer() {
  return (
    <footer className="relative -mt-25 overflow-hidden py-12 pt-37 md:py-25 md:pt-37">
      <FooterBlur />
      <div className="mx-auto grid w-full max-w-3xl grid-cols-2 gap-8 px-6 tracking-tight">
        {links.map((link, index) => (
          <FadeUp key={link.title} delay={index * 0.05}>
            <div className="mb-10 text-center">
              <h3 className="text-muted-foreground mb-8">{link.title}</h3>
              <ul className="flex list-none flex-col items-center gap-8 p-0">
                {link.links.map((item) => (
                  <li key={item.href}>
                    <Link href={item.href} title={item.title}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.15}>
        <p className="mx-auto max-w-md px-6 text-center text-xs leading-relaxed text-muted-foreground">
          Vessa is a journal and reminder, not medical advice or a dosing tool. Always follow your
          prescriber and pharmacist’s instructions.
        </p>
      </FadeUp>
    </footer>
  );
}
